import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { BlockRadioboxComponent } from '@app/components/blocks/block-radiobox/block-radiobox.component';
import { PlRadioModule } from '@app/components/pl-radio/pl-radio.module';

@NgModule({
  imports: [CommonModule, SharedModule, ReactiveFormsModule, PlRadioModule],
  declarations: [BlockRadioboxComponent],
  exports: [BlockRadioboxComponent],
})
export class BlockRadioboxModule {}
